/**
 * USB/HID product identifiers paired with ARMOR3_LEVEL_UP_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */

/**
 * Product identifier (PID) shared by the Armor3 / Level Up Cobra entries.
 * Pair with ARMOR3_LEVEL_UP_VENDOR_ID; both retail names share this identity.
 */
export const ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID = 0x0104
